import { Badge } from "flowbite-react";
import moment from "moment";
import { HiLink, HiTrash, HiX } from "react-icons/hi";
import { Drawer } from "../../components/Modals";
import { getDefaultUserName } from "../../constants/defaultUsers";
import { useResourceInfo } from "../../hooks/useResourceInfo";
import { useRoadmapService } from "../../services";
import { useEpicService } from "../../services/epic";
import "../CreateWorkUnit/CreateWorkUnit.css";
import CreateEpicAdvancedModalBody from "./CreateEpicAdvancedModalBody";
import { useNavigate, useSearchParams } from "react-router-dom";
import { smapBreadCrumbHistoryType } from "../../utils/strategyMapUtils";
import store from "../../redux/store";
import { ENTITY, resetTimelineState, setCurrentEntity } from "../../redux/slices/timeline";
import { resetRoadmap, setSingleRoadmap } from "../../redux/slices/roadmap";

interface CreateAdvancedEpicModalProps {
  setShowModal?: any;
  setSelectedRoadmap?: any;
  isVisible?: any;
  roadmap?: any;
  org_id?: any;
  shouldScrollToTabs?: boolean;
}

export const CreateAdvancedEpicModal = ({
  isVisible,
  setShowModal,
  roadmap,
  setSelectedRoadmap,
  ...props
}: CreateAdvancedEpicModalProps) => {


  const [searchParams] = useSearchParams();
  const breadCrumbHistory = searchParams.get("history"); 
  const navigate = useNavigate();

  const { deleteEpic } = useEpicService();
  const { deleteRoadmap, fetchSingleRoadmap } = useRoadmapService();
  const { getResourceName } = useResourceInfo();
  
  const handleDrawerClose = () => {
    setShowModal(false);
  };

  const isEditMode = !!roadmap?.id;
  const title = isEditMode ? "Edit Advanced Epic" : "New Advanced Epic";
  
  const shouldShowIntegration = (integrationData: any) => {
      return (
          integrationData &&
          (integrationData.integration_id ||
          integrationData.integration_type ||
          integrationData.integration_status)
      );
  };

  const deleteAdvancedEpic = async () => {
    if(!roadmap?.id) return;
    const isDeleted = await deleteEpic(roadmap?.id);
    
    if(isDeleted) {

      setShowModal(false);

        const isRoadmapPage =
          location.pathname.includes("/roadmaps/") ||
          (location.pathname.split("/").filter(Boolean)[0] === "roadmaps" &&
            location.pathname.split("/").filter(Boolean).length > 1);
        const isProjectPage =
          location.pathname.includes("/projects/") ||
          (location.pathname.split("/").filter(Boolean)[0] === "projects" &&
            location.pathname.split("/").filter(Boolean).length > 1);

        const historyObject = JSON.parse(breadCrumbHistory || "{}");

        const strategyMapPages = (
          historyObject as smapBreadCrumbHistoryType
        ).filter((item) => item.url.includes("/strategymaps"));

        const isStragyMapPage = strategyMapPages.length > 0;

        const state_data = store.getState();
        const currentEntity = state_data.timeline.currentEntity;

        if (isProjectPage || isRoadmapPage) {
          if (isRoadmapPage && isStragyMapPage) {
            const lastStrategyMapPage =
              strategyMapPages[strategyMapPages.length - 1];
            navigate(lastStrategyMapPage.url);
            return;
          }
          if (isProjectPage && isStragyMapPage) {
            const lastStrategyMapPage =
              strategyMapPages[strategyMapPages.length - 1];
            navigate(lastStrategyMapPage.url);
            return;
          }

          // if(isRoadmapPage){
          //   navigate("/workitems")
          // }

          // Feature page opened from roadmap
          if (isRoadmapPage && currentEntity === ENTITY.PROJECT) {
            const prevEntityId =
              state_data.roadmap.singleRoadmapRes?.id;

            store.dispatch(resetTimelineState());
            store.dispatch(resetRoadmap());
            store.dispatch(setSingleRoadmap({}));

            await fetchSingleRoadmap(prevEntityId, false);

            store.dispatch(
              setCurrentEntity({
                entity: ENTITY.ROADMAP,
                entityId: prevEntityId,
              }),
            );

            window.location.hash = "";
          }

          if (isProjectPage) {
            navigate("/workitems");
          }
          if (isRoadmapPage) {
            navigate("/workitems");
          }
        } else {
          navigate("/workitems");
        }
      
    }
  }

  return (
    <>
      <Drawer isOpen={isVisible} onClose={handleDrawerClose} position="right">
        <div className="work-unit-drawer bg-white">
          {/* Header */}
          <header className="work-unit-drawer__header flex !flex-col">
            <div className="work-unit-drawer__header-content">
              <div className="flex-1">
                <h2 className="work-unit-drawer__title">{title}</h2>
                {roadmap?.id && (
                  <div className="text-light-text-secondary dark:text-white/70 text-xs mt-0.5">
                    {roadmap.created_by ? (
                      <>
                        Created by:{" "}
                        {getDefaultUserName(roadmap.created_by) ||
                          getResourceName(roadmap.created_by)}{" "}
                        on {moment(roadmap.created_at).format("ll")}
                      </>
                    ) : roadmap.created_at ? (
                      <>Created on: {moment(roadmap.created_at).format("ll")}</>
                    ) : null}
                  </div>
                )}

                {/* Integration information */}
                {roadmap?.id &&
                  roadmap.integration_data &&
                  shouldShowIntegration(roadmap.integration_data) && (
                    <div className="flex flex-wrap gap-2 mt-2">
                      {roadmap.integration_data.integration_type && (
                        <Badge
                          color="indigo"
                          className="px-3 py-1 text-sm font-medium bg-indigo-100 text-indigo-800 dark:bg-indigo-900/30 dark:text-indigo-300 border-none"
                        >
                          {roadmap.integration_data.integration_type
                            .charAt(0)
                            .toUpperCase() +
                            roadmap.integration_data.integration_type
                              .slice(1)
                              .toLowerCase()}
                        </Badge>
                      )}
                      {roadmap.integration_data.integration_id && (
                        <Badge
                          color="info"
                          className="px-3 py-1 text-sm font-medium bg-light-status-info-bg text-light-status-info-text dark:bg-blue-900/30 dark:text-white/60 border-none"
                        >
                          <a
                            href={
                              roadmap.integration_data.integration_url ||
                              `https://${roadmap.integration_data.integration_type}.com/item/${roadmap.integration_data.integration_id}`
                            }
                            target="_blank"
                            rel="noopener noreferrer"
                            className="flex items-center hover:underline"
                            onClick={(e) => e.stopPropagation()}
                          >
                            <HiLink className="mr-1" />
                            {roadmap.integration_data.integration_id}
                          </a>
                        </Badge>
                      )}
                      {roadmap.integration_data.integration_item_type && (
                        <span
                          color="purple"
                          className="px-3 py-0.5 text-xs rounded-md flex items-center justify-center font-medium bg-purple-100 text-purple-300 dark:bg-purple-900/30 !dark:text-purple-300 border-none"
                        >
                          {roadmap.integration_data.integration_item_type
                            .charAt(0)
                            .toUpperCase() +
                            roadmap.integration_data.integration_item_type
                              .slice(1)
                              .toLowerCase()}
                        </span>
                      )}
                      {roadmap.integration_data.integration_status && (
                        <Badge
                          color="success"
                          className="px-3 py-1 text-sm font-medium bg-light-status-success-bg text-light-status-success-text dark:bg-green-900/30 dark:text-green-300 border-none"
                        >
                          <span className="mr-1 font-semibold">Status:</span>{" "}
                          {roadmap.integration_data.integration_status
                            .charAt(0)
                            .toUpperCase() +
                            roadmap.integration_data.integration_status
                              .slice(1)
                              .toLowerCase()}
                        </Badge>
                      )}
                    </div>
                  )}
              </div>

                  {
                    roadmap?.id &&
                      <button
                      type="button"
                      className="text-light-status-error-text hover:text-red-600 dark:text-red-400 dark:hover:text-red-300 hover:bg-light-status-error-bg dark:hover:bg-white/10 p-2 rounded-lg transition-colors duration-200"
                      onClick={() => deleteAdvancedEpic()}
                      >
                        <HiTrash className="text-xl" />
                      </button>
              }
              <button
                type="button"
                className="work-unit-drawer__close-button"
                onClick={handleDrawerClose}
              >
                <HiX className="text-xl" />
              </button>
            </div>
          </header>

          <div className="flex-1 overflow-hidden relative">
            <CreateEpicAdvancedModalBody
              isVisible={isVisible}
              setShowModal={setShowModal}
              roadmap={roadmap}
              setSelectedRoadmap={setSelectedRoadmap}
              type="advanced_epic"
              {...props}
            />
          </div>
        </div>
      </Drawer>
    </>
  );
};

export default CreateAdvancedEpicModal;
